import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import Cookies from "js-cookie";
import { AudioVideoToggle } from "../AudioVideoToggle";

const PcCallAdvisorDetails = () => {
  const [advisor, setAdvisor] = useState(null);
  // Default values to prevent errors if advisor prop is not provided
  const advisorName = advisor?.advisor_name || "Yocket Advisor";
  const profilePicUrl = advisor?.advisor_profile_picture_url || "";
  const studentsHelped = advisor?.count_of_students_helped || "4000+";
  const expertise = advisor?.expertise || "Ivy League Admits";

  useEffect(() => {
    const fetchData = async () => {
      const token = Cookies.get("video-auth-token");

      const response = await fetch(
        process.env.REACT_APP_YOCKET_BACKEND + "/lead/advisor",
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.ok) {
        const json = await response.json();
        setAdvisor(json.data);
      }
    };

    fetchData();
  }, []);

  const advisorDetails = [
    {
      img: "users-gradient-black.svg",
      label: "Students helped: ",
      text: "4000+",
    },
    {
      img: "star-outline-black.svg",
      label: "Advisor ratings: ",
      text: "4.9/5",
    },
    {
      img: "university-cap-outline-black.svg",
      label: "Expertise in: ",
      text: "Scholarships, Ivy admits, etc",
    },
    {
      img: "globe-outline-black.svg",
      label: "Proficient for: ",
      text: "USA, Germany, UK, Australia and Rest of Europe",
    },
  ];

  return isMobile ? (
    <div className="flex flex-col items-center gap-4 w-full px-4">
      {/* -- Heading -- */}
      <p className="text-center text-xl font-bold leading-[130%] text-yocket-neutral-900">
        Welcome to Yocket's on-spot counselling service
      </p>

      {/* <!-- Advisor details --> */}
      <div class="flex h-[280px] w-[212px] flex-col items-center justify-between overflow-clip rounded-xl bg-black pt-10">
        <div className={profilePicUrl ? "space-y-3" : "space-y-4"}>
          {/* Advisor Profile Picture */}
          <div className="h-20 w-20 shrink-0 rounded-full bg-gradient-to-br from-[#B973FF] via-[#B76885] to-[#137FF7] p-[5px] relative mx-auto">
            <div
              className={`h-full w-full overflow-clip rounded-full bg-white ${
                profilePicUrl ? "p-1" : ""
              }`}
            >
              {profilePicUrl ? (
                <img
                  src={profilePicUrl}
                  alt="advisor-profile"
                  className="h-full w-full scale-125 object-cover"
                  format="webp"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center bg-yocket-neutral-800 rounded-full">
                  <span className="text-3xl font-bold text-white">YA</span>
                </div>
              )}
            </div>

            {!profilePicUrl && (
              <div
                className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 rounded-full bg-white flex items-center justify-center w-14 "
                style={{
                  border: "1.678px solid rgba(255, 255, 255, 0.50)",
                }}
              >
                <img
                  src="/svgs/medal-gradient.svg"
                  alt="check"
                  className="h-3 w-3"
                />
                <span className="text-[10px] font-bold">Expert</span>
              </div>
            )}
          </div>

          <div className="text-white text-center">
            <p className="font-bold ">{advisorName}</p>
            <p className="text-sm text-[#CED1D9]">Senior Counsellor</p>
          </div>
        </div>
        {/* <VoAdvisorDetails :key="`vo-advisor-${current}`" :advisor="allAdvisors[current]" /> */}

        {/* <!-- Mic and camera icons --> */}
        <div class="flex items-center justify-center gap-3 pb-4 pt-2 sm:py-4 scale-[85%]">
          <AudioVideoToggle isRounded={true} />
        </div>
      </div>

      <div class="space-y-4 w-full pt-4">
        <div
          className="font-bold py-3 px-4 text-center rounded-lg w-full"
          style={{
            background:
              "radial-gradient(135.63% 115.9% at 4.24% 97.94%, rgba(237, 224, 250, 0.40) 0%, rgba(238, 227, 231, 0.40) 48.06%, rgba(236, 245, 255, 0.40) 100%)",
          }}
        >
          Know your counsellor in depth
        </div>

        <div className="space-y-3 pl-1">
          {advisorDetails.map((detail, index) => (
            <div
              id={`detail${index}`}
              key={`detail-${index}`}
              className="flex items-center gap-2"
            >
              <div className="flex items-start gap-2">
                <img
                  src={`/svgs/${detail.img}`}
                  alt="detail-icon"
                  height="20"
                  width="20"
                />
                <p className="text-sm">
                  <span className="font-bold">{detail.label}</span>
                  <span>{detail.text}</span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : (
    <div className="space-y-6 rounded-xl bg-white p-6 shadow-xl">
      <div className="relative h-[300px] w-full shrink-0 overflow-clip rounded-xl bg-black">
        <div className="grid h-full place-items-center">
          <p className="text-sm font-bold text-white">Your Camera is off</p>
        </div>
      </div>

      {/* Advisor details */}
      <div className="flex w-full items-center gap-4 tracking-[0.12px]">
        {/* Advisor Profile Picture */}
        <div className="h-24 w-24 shrink-0 rounded-full bg-gradient-to-br from-[#B973FF] via-[#B76885] to-[#137FF7] p-[5px] relative">
          <div
            className={`h-full w-full overflow-clip rounded-full bg-white ${
              profilePicUrl ? "p-1" : ""
            }`}
          >
            {profilePicUrl ? (
              <img
                src={profilePicUrl}
                alt="advisor-profile"
                className="h-full w-full scale-125 object-cover"
                format="webp"
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-yocket-neutral-800 rounded-full">
                <span className="text-3xl font-bold text-white">YA</span>
              </div>
            )}
          </div>

          {!profilePicUrl && (
            <div
              className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 rounded-full bg-white flex items-center justify-center w-14 "
              style={{
                border: "1.678px solid rgba(255, 255, 255, 0.50)",
              }}
            >
              <img
                src="/svgs/medal-gradient.svg"
                alt="check"
                className="h-3 w-3"
              />
              <span className="text-[10px] font-bold">Expert</span>
            </div>
          )}
        </div>

        {/* Details */}
        <div className="w-full space-y-2">
          <div>
            <p className="w-fit text-sm font-bold">{advisorName}</p>
            <p className="text-xs">Senior Counsellor</p>
          </div>

          {/* Students helped */}
          <div className="flex w-full items-center gap-4">
            <div>
              <p className="text-xs text-yocket-neutral-400">Students helped</p>
              <div className="flex items-center gap-1.5">
                <img
                  src="/svgs/users-orange-outline.svg"
                  alt="students-helped-count"
                  className="h-4 w-4"
                />
                <span className="text-sm font-bold">{studentsHelped}</span>
              </div>
            </div>

            {/* Expertise */}
            <div>
              <p className="text-xs text-yocket-neutral-400">Expertise</p>
              <p className="text-sm font-bold">{expertise}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PcCallAdvisorDetails;
